import React from 'react';
import { Reveal } from './Reveal';
import { transformationStats } from '../data/transformation';
export function TransformationSection() {
  return <section className="bg-brand-main px-4 py-20 md:py-28" data-id="element-177" data-mp="31xicmqebhih6">
      <Reveal className="mx-auto max-w-5xl" data-id="element-178" data-mp="2wwm6s7aenm94">
        <div className="mx-auto max-w-3xl text-center" data-id="element-179" data-mp="2wzqg1j2q986n">
          <p className="mb-4 text-xs font-extrabold tracking-[0.18em] text-brand-green" data-id="element-180" data-mp="2rxj2wq65vm2q">
            LA TUA TRASFORMAZIONE IN AULA
          </p>
          <h2 className="text-4xl font-extrabold leading-[1.08] tracking-tight text-brand-blue md:text-5xl" data-id="element-181" data-mp="2nysdl57xt8q6">
            Da Insegnante in Difficoltà a <span className="italic text-brand-red" data-id="element-182" data-mp="2e6cw090jym5t">Guida Artistica Sicura.</span>
          </h2>
          <p className="mx-auto mt-5 max-w-2xl text-sm leading-relaxed text-brand-gray md:text-base" data-id="element-183" data-mp="298uj67jezmsj">
            ARTE PRONTA™ trasforma ogni lezione di Arte e Immagine — anche se non hai una formazione artistica
            specifica — con materiali pronti, corretti e strutturati.
          </p>
        </div>
        <div className="mx-auto mt-12 grid max-w-3xl divide-y divide-brand-dark overflow-hidden rounded-2xl border border-brand-dark bg-brand-alt shadow-sm sm:grid-cols-3 sm:divide-x sm:divide-y-0" data-id="element-184" data-mp="fa1891rmr6vx">
          {transformationStats.map(({
          value,
          label
        }) => <div key={value} className="px-5 py-6 text-center" data-id="element-185" data-mp="abzdhjkudj4m">
              <strong className="block font-display text-3xl font-extrabold leading-none text-brand-red" data-id="element-186" data-mp="aciyxa9papne">
                {value}
              </strong>
              <span className="mt-2 block text-[11px] font-semibold leading-snug text-brand-gray" data-id="element-187" data-mp="1316nbepqxv56">{label}</span>
            </div>)}
        </div>
      </Reveal>
    </section>;
}